import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { article_path } from '@routes';
import { ClickTarget, click } from '@tracking';

interface ArticleHeaderProps {
  className?: string;
  slug: string;
  title: string;
}

const ArticleHeader = ({ className, slug, title, ...rest }: ArticleHeaderProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <h3 className={clsx('m-0 mb-4 font-suisse-works text-black', className)} {...rest}>
      <a
        href={article_path(slug)}
        onClickCapture={() =>
          trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title }))
        }
        className="text-black transition-colors duration-200 hover:text-primary-magenta"
      >
        {title}
      </a>
    </h3>
  );
};

export default ArticleHeader;
